import React, { useEffect, useState } from 'react'
import { Col, Image, Row } from 'react-bootstrap'
import ImgBGProfile from '../../../images/bg-profile.png'
import imgUser from '../../../images/user-bg.png'
import { useSearchParams } from 'react-router-dom'
import { getEmpsProfilesAPI } from '../../../services/employee'
import { fnDateEn } from '../../../helper/fnDateEn'

function FormPresonals() {
  let [searchParams, setSearchParams] = useSearchParams()
  const orgId = searchParams.get('org')
  const code = searchParams.get('code')
  const status = searchParams.get('status')

  const [profile, setProfile] = useState({})

  useEffect(() => {
    const getEmpsProfiles = async () => {
      const data = await getEmpsProfilesAPI({ orgId, code })
      if (!data) return
      if (data.status) {
        setProfile(data.result[0])
      }
    }
    getEmpsProfiles()
  }, [orgId, code])
  return (
    <>
      <div className="position-relative">
        <Image
          src={ImgBGProfile}
          fluid
          className="rounded-3"
          style={{ width: '272px', height: '130px', objectFit: 'cover' }}
        />
        <div
          className="position-absolute"
          style={{
            top: '60%',
            left: '20%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Image
            src={profile?.image_url ?? imgUser}
            fluid
            style={{ width: '60px', height: '60px', objectFit: 'cover' }}
            className="rounded-circle bg-white"
            onError={(event) => {
              event.target.src = imgUser
              event.onerror = null
            }}
          />
        </div>
      </div>
      <p className="text-center mb-0 mt-3 small">
        {profile?.title_en} {profile?.name_en} {profile?.surname_en}
      </p>
      <p className="text-center fw-light font-small-2">
        {profile?.title_th}
        {profile?.name_th} {profile?.surname_th} ({profile?.nickname_th})
      </p>
      <div className="m-1 p-2 rounded-3" style={{ backgroundColor: '#EEF4FF' }}>
        <div className="d-flex justify-content-between ">
          {status === '1' ? (
            <p className="mb-2 font-small-2">Start Date</p>
          ) : (
            <p className="mb-2 font-small-2">Last Date</p>
          )}
          <p className="font-small-2 mb-2 fw-light text-muted">
            {/* resign date */}
            {status === '1' ? (
              <>
                {profile?.start_date
                  ? fnDateEn(profile?.start_date).format('DD MMMM YYYY')
                  : '-'}
              </>
            ) : (
              <>
                {profile?.last_date
                  ? fnDateEn(profile?.last_date).format('DD MMMM YYYY')
                  : '-'}
              </>
            )}
          </p>
        </div>
        <div className="d-flex justify-content-between border-bottom">
          <p className="mb-2 font-small-2">Effective date</p>
          <p className="font-small-2 mb-2 fw-light text-muted">
            {profile?.effective_date
              ? fnDateEn(profile?.effective_date).format('DD MMMM YYYY')
              : '-'}
          </p>
        </div>
        <Row className="mt-3">
          <Col xl={8}>
            <p className="font-small-2  m-0">Code</p>
            <p className="font-small-2 fw-light text-muted ">{code}</p>
          </Col>
          <Col xl={4}>
            <p className="font-small-2 m-0">Level</p>
            <p className="font-small-2 fw-light text-muted">
              {profile?.level_id}
            </p>
          </Col>
        </Row>
        <Row>
          <Col xl={8}>
            <p className="font-small-2 m-0">Direct Report </p>
            <p className="font-small-2 fw-light text-muted">
              {profile?.detail_report_to?.title_en || '-'}{' '}
              {profile?.detail_report_to?.name_en || '-'}{' '}
              {profile?.detail_report_to?.surname_en || '-'}
            </p>
          </Col>
          <Col xl={4}>
            <p className="font-small-2 m-0">Type </p>
            <p className="font-small-2 fw-light text-muted">{profile?.type}</p>
          </Col>
        </Row>

        <p className="font-small-2 m-0">Group </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.division_en || '-'}
          <span>{` (${profile?.division || ''})`}</span>
        </p>

        <p className="font-small-2 m-0">Division </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.faction_en || '-'}
          <span>{` (${profile?.faction || ''})`}</span>
        </p>
        <p className="font-small-2 m-0">Department </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.department_en || '-'}
          <span>{` (${profile?.department || ''})`}</span>
        </p>

        <p className="font-small-2 m-0">Team </p>
        <p className="font-small-2 fw-light text-muted">
          {profile?.team_en || '-'}
        </p>

        <p className="font-small-2 m-0">Position </p>
        <p className="font-small-2 fw-light text-muted ">
          {profile?.position_en || '-'}
        </p>
      </div>
    </>
  )
}

export default FormPresonals
